<div
  [ngClass]="{
    'toggled': !isMenuCollapsed,
    'primary': isPrimary
  }"
  class="mobile-button-wrapper"
>
  <button
    (click)="toggle()"
    aria-controls="navbar"
    aria-expanded="false"
    class="mobile-button"
    data-target="#navbar"
    data-toggle="collapse"
    type="button"
  >
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button>
</div>